import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { api } from '../utils/api';

/**
 * Returns user role from DB only (GET /api/vendors/me-role). Never from Clerk.
 * Only checks when user is authenticated to avoid unnecessary 401 errors.
 * On 404 or error, treats user as customer (isVendor: false).
 * @returns {{ isVendor: boolean, isOwner: boolean, loading: boolean }}
 */
export function useMeRole() {
  const { getToken, isSignedIn } = useAuth();
  const [role, setRole] = useState({ isVendor: false, isOwner: false, loading: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setRole(r => ({ ...r, loading: true }));
      // Only check role if user is signed in
      if (!isSignedIn) {
        if (!cancelled) {
          setRole({ isVendor: false, isOwner: false, loading: false });
        }
        return;
      }
      try {
        const res = await api('/api/vendors/me-role', { getToken });
        const data = await res.json().catch(() => ({}));
        if (!cancelled && res.ok) {
          setRole({ isVendor: !!data.isVendor, isOwner: !!data.isOwner, loading: false });
        } else {
          if (!cancelled) setRole({ isVendor: false, isOwner: false, loading: false });
        }
      } catch {
        if (!cancelled) setRole({ isVendor: false, isOwner: false, loading: false });
      }
    })();
    return () => { cancelled = true; };
  }, [getToken, isSignedIn]);

  return role;
}
